function DependenteErrorHandler(response = {}) {
  if (!(response && response.data)) return;
  const { data = {} } = response;
  const { error = {} } = data;
  const { httpCode: statusCode = "no-code", message = "", errorCode } = error;


  
  if (statusCode === 409 && message === "Invite sendtime is still valid.") {
    return {
      ...data,
      code: statusCode,
      error: {
        errorCode,
        warning: {
          id: "limite-de-reenvios-atingido",
          title: "Olá",
          message: `O tempo de envio do convite ainda é válido, tente novamente mais tarde!`,
        },
      },
    };
  } else if (statusCode === 409 && message === "There is already an invite for this product.") {
    return {
      ...data,
      code: statusCode,
      error: {
        errorCode,
        warning: {
          id: "ja-existe-um-convite-pendente",
          title: "Convite já enviado",
          message: `Já existe um convite ativo para esse usuário!`,
        },
      },
    };
  } else if (errorCode === "USER_ALREADY_HAS_HOLDER") {
    return {
      ...data,
      code: statusCode,
      error: {
        errorCode,
        warning: {
          id: "cpf-ja-possui-outro-titular",
          title: "CPF Inválido",
          message: `O CPF informado já é dependente de outro usuário!`,
        },
      },
    };
  } else if (errorCode === "CANNOT_INVITE_SAME_ID") {
    return {
      ...data,
      code: statusCode,
      error: {
        errorCode,
        warning: {
          id: "nao-e-possivel-enviar-um-convite-para-o-mesmo-cpf",
          title: "CPF inválido",
          message: `Não é possível enviar um convite para o mesmo CPF!`,
        },
      },
    };
  } else if (
    statusCode === 422 &&
    message === "User not eligible to perform this operation"
  ) {
    return {
      ...data,
      code: statusCode,
      error: {
        errorCode,
        warning: {
          id: "erro-ao-enviar-convite",
          title: "Ocorreu um erro ao enviar o convite",
          message: "Verifique se as informações estão corretas!",
        },
      },
    };
  } else if (statusCode === 401) {
    return {
      ...data,
      code: statusCode,
      error: {
        errorCode,
        warning: {
          id: "sessao-expirada",
          title: "Sessão expirada",
          message: "efetue o login novamente",
        },
      },
    };
  }else if (statusCode === 404) {
    return {
      ...data,
      code: statusCode,
      error: {
        errorCode,
        warning: {
          id: "invite-not-found",
          title: "Ops, ocorreu um erro",
          message: "O convite não foi encontrado",
        },
      },
    };
  } else if (statusCode === 500) {
    return {
      ...data,
      code: statusCode,
      error: {
        errorCode,
        warning: {
          id: "ERRO-500",
          title: "Ops",
          message: "Ocorreu um erro inesperado, tente novamente mais tarde!",
          systemError: data,
        },
      },
    };
  } else {
    return {
      ...data,
      code: statusCode,
      error: {
        errorCode,
        warning: {
          id: "ERRO",
          title: "Ocorreu um erro inesperado!",
          message: "Verifique sua conexão com a internet e tente novamente",
          systemError: data,
        },
      },
    };
  }
}
export default DependenteErrorHandler;
